export const LocalStorageKey = {
  CHAT_INPUT: 'CHAT_INPUT',
  CUSTOM_TABLE: 'CUSTOM_TABLE',
  HISTORY: 'HISTORY',
  LAST_VISITED_PAGE: 'LAST_VISITED_PAGE',
  OFFER_INSTANCE_DETAILS_HEADER: 'OFFER_INSTANCE_DETAILS_HEADER',
  TASK_MESSAGE: 'TASK_MESSAGE',
  RESOURCE_CALENDAR: 'RESOURCE_CALENDAR',
} as const;

export type LocalStorageKey = (typeof LocalStorageKey)[keyof typeof LocalStorageKey];

type ClearItemHandler = (params: { key: LocalStorageKey; subKey?: string }) => void;
type GetItemHandler = <T>(params: { key: LocalStorageKey; subKey?: string }) => T | null;
type SetItemHandler = (params: { key: LocalStorageKey; subKey?: string; value: unknown }) => void;

const setItem: SetItemHandler = params => {
  localStorage.setItem(params.key + parseSubkey(params.subKey), JSON.stringify(params.value));
};

const getItem: GetItemHandler = params => {
  const item = localStorage.getItem(params.key + parseSubkey(params.subKey));
  if (item === null) return null;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return JSON.parse(item);
};

const clearItem: ClearItemHandler = (params): void => {
  localStorage.removeItem(params.key + parseSubkey(params.subKey));
};

export const localStorageUtil: {
  clearItem: ClearItemHandler;
  getItem: GetItemHandler;
  setItem: SetItemHandler;
} = {
  clearItem,
  getItem,
  setItem,
};

const parseSubkey = (subKey: string | undefined) => {
  if (!subKey) {
    return;
  }

  return '_' + subKey;
};
